import React from 'react'
import type { Icon } from 'shared/utils'

const Logo = (props: Icon) => {
    const { size = 80, className = 'logo', color, background } = props
    return (
        <svg
            className={className}
            width={size}
            height={(size * 32) / 30}
            viewBox="0 0 50 50"
            preserveAspectRatio="none">
            <defs>
                <clipPath id="clippath">
                    <rect
                        fill="none"
                        x="-1.87"
                        y="-3.66"
                        width="53.74"
                        height="60.61"
                    />
                </clipPath>
                <clipPath id="clippath-1">
                    <rect
                        fill="none"
                        x="-1.87"
                        y="-3.66"
                        width="53.74"
                        height="60.61"
                    />
                </clipPath>
            </defs>
            <g id="Logo_PrimaryBG_SafeZone_CMJN">
                <g>
                    <g>
                        <path
                            fill="#f8f1df"
                            d="M45.91,15.08c0-1.41-.5-2.93-1.46-4.42-.95-1.48-2.33-2.89-4-4.07-2.76-1.95-7.68-4.28-15.45-4.28s-12.75,2.33-15.5,4.28c-1.66,1.18-3.03,2.59-3.97,4.08-.94,1.48-1.43,3.01-1.43,4.41v25.01c0,1.95,1.49,4.01,3.9,5.36,3.21,1.81,8.14,2.55,17.01,2.55s13.8-.74,17.01-2.55c2.4-1.36,3.9-3.41,3.9-5.36V15.08Z"
                        />
                        <path
                            fill="#e42313"
                            d="M42.7,27.17c.42.31.69.77.69,1.37,0,.8-.65,1.58-1.62,1.58-.83,0-1.03-.6-2.22-.6-.98,0-2.25.7-2.25,2.62,0,1.73.93,2.66,2.3,2.66.41,0,.8-.21.8-.52,0-.25-.23-.35-.56-.35-.66,0-1.56-.47-1.56-1.46,0-1.09.82-1.58,1.88-1.58h.59c2.04,0,3.06,1.12,3.06,2.74,0,2.56-1.8,4.31-4.64,4.31s-5.45-1.85-5.45-5.8,2.74-5.91,5.56-5.91c1.57,0,2.68.4,3.42.94"
                        />
                        <path
                            fill="#e42313"
                            d="M26.61,33.23c0-.22.07-.31.21-.31.1,0,.17.06.25.23l1.68,3.26c.64,1.24,1.33,1.53,2.07,1.53,1.27,0,1.97-.95,1.97-2.15v-7.47c0-1.17-.68-2.1-1.92-2.1s-1.92.93-1.92,2.1v2.61c0,.22-.07.31-.21.31-.1,0-.17-.06-.25-.23l-1.68-3.26c-.64-1.24-1.3-1.53-2.07-1.53-1.27,0-1.97.95-1.97,2.15v7.47c0,1.17.68,2.1,1.92,2.1s1.92-.93,1.92-2.1v-2.61Z"
                        />
                        <path
                            fill="#e42313"
                            d="M10.14,35.81v-1.72c0-.14.06-.25.21-.25.19,0,.24.19.29.29.28.66,1.09,2.08,1.84,2.91.51.56,1.14.91,1.8.91,1.12,0,2.07-.98,2.07-2.03,0-.65-.28-1.14-.81-1.72-.68-.74-1.47-1.7-1.76-2.15-.11-.17-.12-.28-.12-.33,0-.13.07-.23.22-.36.34-.31,1.17-1.1,1.63-1.81.35-.54.5-1.04.5-1.45,0-1.05-.95-1.87-1.99-1.87-.66,0-1.29.37-1.72,1.06-.57.92-1.24,1.98-1.68,2.41-.11.11-.17.13-.25.13-.15,0-.21-.1-.21-.25v-1.21c0-1.18-.7-2.14-1.97-2.14s-1.97.95-1.97,2.14v7.44c0,1.18.69,2.14,1.97,2.14s1.97-.95,1.97-2.14"
                        />
                        <path
                            fill="#f07e26"
                            d="M7.19,39.17c-.7,0-1.02.34-1.02.93,0,1.04.96,2.49,2.84,3.55,3.14,1.78,8.53,2.28,15.99,2.28s12.85-.51,15.99-2.28c1.89-1.06,2.84-2.51,2.84-3.55,0-.59-.31-.93-1.02-.93H7.19Z"
                        />
                        <path
                            fill="#f07e26"
                            d="M42.81,16.1c.7,0,1.02-.36,1.02-1.02,0-3.87-5.93-10.69-18.83-10.69S6.17,11.21,6.17,15.08c0,.65.31,1.02,1.02,1.02h35.63Z"
                        />
                        <path
                            fill="#e42313"
                            d="M15.43,25.52c1.96,0,3-1.17,3-2.65v-4.07c0-.73-.42-1.31-1.2-1.31s-1.2.58-1.2,1.31v3.94c0,.29-.17.63-.6.63s-.58-.34-.58-.63v-3.94c0-.73-.43-1.31-1.21-1.31s-1.2.58-1.2,1.31v4.07c0,1.47,1.03,2.65,2.98,2.65"
                        />
                        <path
                            fill="#e42313"
                            d="M35.94,22.44c.58,0,1.04-.35,1.04-.97s-.46-.97-1.04-.97h-.83c-.21,0-.3-.12-.3-.28v-.19c0-.16.1-.28.3-.28h1.09c.68,0,1.21-.4,1.21-1.12s-.53-1.11-1.21-1.11h-2.28c-.95,0-1.41.56-1.41,1.31v5.33c0,.75.46,1.3,1.41,1.3h2.28c.68,0,1.21-.4,1.21-1.12s-.53-1.11-1.21-1.11h-1.09c-.21,0-.3-.12-.3-.28v-.23c0-.16.1-.28.3-.28h.83Z"
                        />
                        <path
                            fill="#e42313"
                            d="M31.19,18.1c.28.22.46.53.46.94,0,.56-.43,1.09-1.08,1.09-.56,0-.69-.41-1.49-.41-.65,0-1.5.48-1.5,1.81,0,1.2.62,1.84,1.52,1.84.29,0,.54-.14.54-.36,0-.17-.15-.24-.37-.24-.45,0-1.04-.33-1.04-1,0-.76.56-1.1,1.27-1.1h.39c1.35,0,2.03.77,2.03,1.9,0,1.76-1.2,2.97-3.09,2.97s-3.63-1.27-3.63-4,1.82-4.08,3.7-4.08c1.06,0,1.78.28,2.28.65"
                        />
                        <path
                            fill="#e42313"
                            d="M21.36,28.51c0-1.27-.74-2.28-2.09-2.28s-2.09,1.02-2.09,2.28v7.15c0,1.27.74,2.28,2.09,2.28s2.09-1.02,2.09-2.28v-7.15Z"
                        />
                        <path
                            fill="#e42313"
                            d="M11.09,21.35c-.06-.05-.12-.1-.12-.15,0-.06.04-.08.1-.16.23-.27.46-.69.46-1.31,0-1.45-.98-2.22-2.5-2.22h-1.44c-.95,0-1.41.56-1.41,1.31v5.33c0,.75.46,1.3,1.41,1.3h1.7c1.61,0,2.59-1.08,2.59-2.42,0-1.08-.64-1.57-.79-1.69M8.3,19.6c0-.16.1-.28.3-.28h.16c.52,0,.68.36.68.68,0,.29-.16.7-.68.7h-.16c-.21,0-.3-.12-.3-.28v-.82ZM8.82,23.65h-.22c-.21,0-.3-.12-.3-.28v-.94c0-.16.1-.28.3-.28h.22c.58,0,.75.39.75.74,0,.31-.17.76-.75.76"
                        />
                        <path
                            fill="#e42313"
                            d="M24.7,23.42c-.35-.46-.66-.86-.82-1.28-.04-.1-.01-.18.1-.27.37-.29.81-.93.81-1.95,0-1.54-1.27-2.41-2.8-2.41h-1.37c-.96,0-1.41.56-1.41,1.31v5.39c0,.72.42,1.3,1.2,1.3s1.2-.58,1.2-1.3v-1.28c0-.16.07-.23.19-.23.15,0,.19.08.22.23.11.62.4,1.45.73,1.87.41.54.8.71,1.18.71.63,0,1.17-.5,1.17-1.11,0-.41-.17-.71-.39-.99M21.93,20.91h-.17c-.21,0-.3-.12-.3-.28v-.82c0-.16.1-.28.3-.28h.17c.51,0,.66.36.66.68s-.16.7-.66.7"
                        />
                        <path
                            fill="#e42313"
                            d="M43.44,23.42c-.41-.52-.66-.86-.82-1.28-.04-.1-.01-.18.1-.27.37-.29.81-.93.81-1.95,0-1.54-1.27-2.41-2.8-2.41h-1.37c-.96,0-1.41.56-1.41,1.31v5.39c0,.72.42,1.3,1.2,1.3s1.2-.58,1.2-1.3v-1.28c0-.16.07-.23.19-.23.15,0,.19.08.22.23.11.62.4,1.45.73,1.87.41.54.8.71,1.18.71.63,0,1.17-.5,1.17-1.11,0-.41-.17-.71-.39-.99M40.67,20.91h-.17c-.21,0-.3-.12-.3-.28v-.82c0-.16.1-.28.3-.28h.17c.51,0,.66.36.66.68s-.16.7-.66.7"
                        />
                        <path
                            fill="#e42313"
                            d="M43.61,37.33c-.34,0-.6.27-.6.6,0,.34.25.6.6.6s.6-.25.6-.6c0-.32-.25-.6-.6-.6M43.61,38.41c-.23,0-.47-.17-.47-.48s.24-.47.47-.47.47.17.47.47-.24.48-.47.48"
                        />
                        <path
                            fill="#e42313"
                            d="M43.68,38c.12-.02.17-.1.17-.19,0-.11-.09-.19-.23-.19h-.17s-.06.03-.06.07v.51s.03.06.06.06c.04,0,.07-.03.07-.06v-.17h.02l.18.21s.03.03.05.03c.04,0,.06-.02.06-.06,0-.01,0-.03-.02-.04l-.13-.15ZM43.53,37.9v-.17h.1c.06,0,.1.03.1.08,0,.05-.04.09-.11.09h-.09Z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export { Logo }
